(function () {
  function init() {
    var header = document.querySelector('.albirouhi-header');
    if (!header) return;

    var lastY = window.scrollY || 0;
    var ticking = false;
    var SHOW_AT_TOP = 60;
    var DELTA = 4;

    function update() {
      var currentY = window.scrollY || 0;
      var delta = currentY - lastY;
      var menuOpen = !!header.querySelector('details[open]');

      if (currentY < SHOW_AT_TOP || menuOpen) {
        header.classList.remove('is-hidden');
      } else if (delta > DELTA) {
        header.classList.add('is-hidden');
      } else if (delta < -DELTA) {
        header.classList.remove('is-hidden');
      }

      lastY = currentY;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
